import { DataTestId, TextKey } from '@mews-commander/enums';
import { LocalizedMinorHighlight, LocalizedSmallParagraph } from '@mews-commander/ui';
import { hftImage as hftImagePath } from '@mews-commander/assets';
import { MewsImage } from '@mews/business-components';
import { Button } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { Widget } from '@mews-commander/dashboard/widgets';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { searchMarketplace } from '../actions';

const imageHeight = '196px';
const hotelForTreesSearchTerm = 'Hotels for Trees';

export const HotelsForTreesWidget = () => {
    const dispatch = useCommanderThunkDispatch();

    const handleClick = () => {
        dispatch(searchMarketplace(hotelForTreesSearchTerm));
    };

    return (
        <Widget titleTextKey={TextKey.Marketplace}>
            <MewsImage
                src={hftImagePath}
                height={imageHeight}
                objectFit="contain"
                objectPosition="left top"
                shouldShowLoader
            />
            <LocalizedMinorHighlight textKey={TextKey.MarketplaceHotelsForTreesWidgetHeaderText} />
            <LocalizedSmallParagraph textKey={TextKey.MarketplaceHotelsForTreesWidgetText} />
            <div>
                <Button
                    onClick={handleClick}
                    data-test-id={DataTestId.MarketplaceHotelsForTreesWidgetButton}
                    type="submit"
                >
                    <LocalizedText textKey={TextKey.MarketplaceHotelsForTreesWidgetButtonText} />
                </Button>
            </div>
        </Widget>
    );
};
